import config from '../../config'
import http from '../http'

export const forgotPassword = (email) => {
  return http.POST(config.serverEndpoint + '/user/forgotPassword', { email })
}

export const resetPassword = (newPassword) => {
  return http.POST(config.serverEndpoint + '/user/resetPassword', { newPassword })
}
